<template>
  <div>
    <div class="feature-top">
      <product-feature-summary
        :imagePath="'/static/products/reply-call-pc/feature/summary.jpg'"
        :altText="`PCお客様呼出しシステムのリプライコールPC`"
        :headerText="
          `最大500台の受信機に対応！255個までの登録コードをワンタッチで
          受信機へ送信できるので、業務のより円滑な遂行が可能になります！`
        "
        :detailText="
          `リプライコールなら、お客様の満足度もアップ！待ち時間をもっともっと快適に過ごしていただくことができます。
          安心して業務が行える「受信確認機能」や「圏外お知らせ機能」、使用場所を選ばず広い敷地でもOK！
          リプライコール PCは、リプライコールをパソコンやタブレットから操作することができます。`
        "
        :color="'green'"
      />

      <div class="feature-content">
        <content-header
          title="PC/タブレットを活用して受信機をかんたん呼び出し"
          withBorder="true"
          fontColor="black"
          borderColor="green"
          style="width: 70%;"
        />
        <div style="width: 70%;">
          <p>
            送信機とWindows
            PC※をUSB接続することにより、マウス操作やタッチパネル操作での受信機呼び出しや登録コードの送信などが可能。従来のリプライコールを上回る高機能&高操作性を実現しています。
          </p>
          <p>
            ※ Windows7/8/8.1/10 を搭載する PC ならびにタブレットに対応
          </p>
        </div>
        <img
          style="top: -30px; width: 30%; height: auto;"
          :style="this.$isPC ? '' : 'top: 0px'"
          v-lazy="'/static/products/reply-call-pc/feature/feature_01.png'"
        />
      </div>

      <div class="feature-content">
        <content-header
          title="受信機は最大500台まで対応。255個までの登録コードを管理"
          withBorder="true"
          fontColor="black"
          borderColor="green"
        />
        <p>
          1台のリプライコール
          PCが対応可能な受信機数は最大500台。業務の可能性を大きく拡げるパワフル設計です。
        </p>
        <p>
          また、PC側で255の登録コード※の管理に対応。受信機へワンタッチで登録コードを送信できます。
        </p>
        <p>
          ※1~FFまでの英数字の組み合わせ。事前にA1は本部などと決めておくことで業務を円滑に進行することが可能になります。
        </p>
      </div>

      <div class="feature-content">
        <content-header
          title="「呼び出し」が完了したことをPC側で確認可能"
          withBorder="true"
          fontColor="black"
          borderColor="green"
        />
        <p>
          送信した登録コードが受信機に届いたかどうかや、受信者が受信を確認したかどうかを、PCの画面上で確認できます。
        </p>
        <p>
          通信エラーになった場合には、PCから簡単操作で登録コードを再送できるため、業務をスムーズに進行できます。
        </p>
      </div>

      <div class="feature-content">
        <content-header
          title="受信機に呼び出しコードを表示。呼ばれている場所がすぐに判明"
          withBorder="true"
          fontColor="black"
          borderColor="green"
          style="width: 80%;"
        />
        <div style="width: 80%;">
          <p>
            呼び出しを受けると、受信機の表示窓に登録コードを表示。どこから呼ばれているかが、すぐにわかります。
          </p>
          <p>
            また、受信LED・ブザー音・バイブレーションなどでも呼び出しをお知らせ。呼び出しを見逃す心配がありません。
          </p>
        </div>
        <img
          style="top: -60px; width: 20%; height: auto;"
          :style="this.$isPC ? '' : 'top: 0px'"
          v-lazy="'/static/products/reply-call-pc/feature/feature_02.png'"
        />
      </div>
    </div>

    <div class="feature-section" v-if="this.$isPC">
      <div class="circle-parent">
        <div class="circle-heading green">
          <h2 class="circle-heading-title">操作の流れ</h2>
        </div>
      </div>

      <div class="operation-flow">
        <div class="header">
          <h3>
            かんたん操作で、PC/タブレットからお客様をお呼び出し。
          </h3>
        </div>
        <div class="body">
          <div class="operation-empty" />

          <div class="operation-block">
            <img
              v-lazy="'/static/products/reply-call-pc/feature/operation_01.jpg'"
            />
            <div class="operation-block-title">
              1. 受信機を配布
            </div>
            <p>
              設定された受信機番号をご確認のうえ、呼び出したい方へ受信機をお渡しください。
            </p>
          </div>

          <div class="operation-arrow" />

          <div class="operation-block">
            <img
              v-lazy="'/static/products/reply-call-pc/feature/operation_02.jpg'"
            />
            <div class="operation-block-title">
              2. 呼び出し
            </div>
            <p>
              <span style="color: red;">❶</span>
              あらかじめ登録しておいた登録コードを選択
            </p>
            <p>
              <span style="color: red;">❷</span>
              受信機番号を入力
            </p>
            <p>
              <span style="color: red;">❸</span>
              コールボタンをクリック
            </p>
          </div>

          <div class="operation-arrow" />

          <div class="operation-arrow" />

          <div class="operation-block">
            <img
              v-lazy="'/static/products/reply-call-pc/feature/operation_03.jpg'"
            />
            <div class="operation-block-title">
              3. 受信
            </div>
            <p>
              受信機は呼び出しを受けると登録コード表示・受信LED・ブザー音・バイブレーションで呼び出しを通知（切替可能）。
              また呼び出しが成功すると、PCの画面表示が
              <img
                v-lazy="'/static/products/reply-call-pc/feature/symbol_01.png'"
                style="height: 16px; vertical-align: text-bottom;"
              />
              から
              <img
                v-lazy="'/static/products/reply-call-pc/feature/symbol_02.png'"
                style="height: 16px; vertical-align: text-bottom;"
              />
              に変わります。
            </p>
          </div>

          <div class="operation-arrow" />

          <div class="operation-block">
            <img
              v-lazy="'/static/products/reply-call-pc/feature/operation_04.jpg'"
            />
            <div class="operation-block-title">
              4. 確認～呼び出し完了
            </div>
            <p>
              受信機の確認ボタンを押すことで、受信LED・ブザー音・バイブレーションを停止できます。
            </p>
            <p>
              またPC側へ確認完了信号が送信されます。
            </p>
            <p>
              確認完了信号を受信するとPCの画面表示が
              <img
                v-lazy="'/static/products/reply-call-pc/feature/symbol_02.png'"
                style="height: 16px; vertical-align: text-bottom;"
              />
              から
              <img
                v-lazy="'/static/products/reply-call-pc/feature/symbol_03.png'"
                style="height: 16px; vertical-align: text-bottom;"
              />
              に変わります。
            </p>
          </div>

          <div class="operation-empty" />
        </div>
      </div>
    </div>

    <div class="feature-section">
      <div class="circle-parent">
        <div class="circle-heading green">
          <h2 class="circle-heading-title">主な機能</h2>
        </div>
      </div>

      <div class="main-function">
        <div class="header">
          <h3>
            使い勝手に優れた機能を多数搭載。
          </h3>
        </div>
        <div class="body">
          <img
            class="main-image"
            v-lazy="'/static/products/reply-call-pc/feature/function_01.jpg'"
          />
          <div class="function" style="width: 100%;">
            <h3 class="function-title">
              画面上で通信履歴などを確認可能。トラブルを防止
            </h3>
            <div class="function-detail">
              PC用アプリケーションの画面右側では［通信履歴］を表示。<br />
              受信機の呼び出し状況を、わかりやすいアイコン表示により、ひと目で確認することができます。設定により、〈受信機受信〉や〈呼び出し完了〉の<br />
              受信機を非表示にすることも可能。<br />
              通信エラーが発生している受信機や呼び出しが完了していない受信機だけが表示されるため、トラブル対応が容易になります。<br />
              通信エラーの受信機へは、ダブルクリック＋コールボタンクリックの簡単操作で再送することができます。
            </div>
          </div>

          <div class="function">
            <h3 class="function-title">
              PCならではの簡単操作。<br />
              トレーニングは不要
            </h3>
            <div class="function-detail">
              登録コードをマウスで選択し、受信機番号を入力、そしてコールボタンをクリックするだけ。リプライコール
              PC
              は、非常に簡単な操作で、受信機を呼び出すことを可能にしています。<br />
              したがって操作習得のための特別なトレーニングは一切不要。誰でも簡単に使いこなしていただける画期的なシステムです。
            </div>
          </div>

          <div class="function">
            <h3 class="function-title">
              ディスプレイサイズにフィット。<br />
              最適サイズ表示
            </h3>
            <div class="function-detail">
              PC用アプリケーションはディスプレイの全画面で表示する「全画面表示」はもちろん、ウインドウ表示にも対応。画面の解像度に最適なサイズで表示します（1920×1080および、1366×768、960×540ピクセル表示のPCにジャストフィットとなります）。<br />
              より使いやすく、見やすい表示サイズで活用することが可能です。
            </div>
          </div>

          <div class="function">
            <h3 class="function-title">
              簡単インストールを実現。<br />
              細かな設定も可能に
            </h3>
            <div class="function-detail">
              PC用アプリケーションは、CD-ROMで提供。インストーラーを用意しているため、PC操作が不慣れな方でも簡単にインストールしていただけます。またアプリケーションの各種機能を簡単に設定できる設定画面もご用意。設定画面では応答待ち時間や、再送回数などを細かく設定できます。
            </div>
            <img
              v-lazy="'/static/products/reply-call-pc/feature/function_02.png'"
            />
          </div>

          <div class="function">
            <h3 class="function-title">
              「圏外」や「エラー発生」は<br />
              受信機でも確認OK
            </h3>
            <div class="function-detail">
              受信機が「圏外」の場合は、表示窓にEEと表示（交互点滅）されるため、通信ミスを最小限に抑えることが可能です。<br />
              また、設定した時間内に確認ボタンが押されず、タイムアウトエラーとなった場合には、表示窓にccと表示。<br />
              受信機側でもタイムアウトエラーの発生がひと目でわかります。
            </div>
            <img
              v-lazy="'/static/products/reply-call-pc/feature/function_03.png'"
            />
          </div>

          <div class="appeal-block">
            <div class="appeal-title">
              お求めやすいプライスを実現。カスタマイズにも対応
            </div>
            <div class="appeal-detail">
              スマートフォンやPHSなどを利用したシステムと比較すると、イニシャルコストならびにランニングコストなどの面で断然経済的。<br />
              リプライコール
              PCなら、コストを掛けずに、ビジネスコミュニケーションの可能性を大きく拡げることが可能です。<br />
              また、企業様のニーズに合わせたシステムのカスタマイズも承っておりますので、お気軽にお問い合わせください。
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="feature-section">
      <div class="circle-parent">
        <div class="circle-heading green">
          <h2 class="circle-heading-title">システム<br />構成例</h2>
        </div>
      </div>
      <div class="system-config">
        <img v-lazy="'/static/products/reply-call-pc/feature/system.png'" />
      </div>
    </div>

    <div class="feature-section">
      <div class="circle-parent">
        <div class="circle-heading green">
          <h2 class="circle-heading-title">使用例</h2>
        </div>
      </div>
      <div class="header">
        <h3>
          病院・クリニックで離れた患者様を呼び出す
        </h3>
      </div>
      <img
        style="width: 100%;max-width: 850px;"
        src="/static/products/reply-call-pc/usage-example.png"
        alt="離れた患者様を呼び出すのにおすすめの呼び出しベル"
      />
      <p class="cta-microcopy" style="margin-top: 2.5rem">
        ＼この使い方にピンときた方へ／
      </p>
      <div
        class="column_wrap_cta"
        style="background: none; padding: 0; margin-bottom: 3.5rem"
      >
        <a class="column_wrap_cta_contact" href="/contact"
          >無料見積もり・お問い合わせはこちら</a
        >
      </div>
    </div>

    <div class="feature-section worry">
      <div class="circle-parent">
        <div class="circle-heading green">
          <h2 class="circle-heading-title">お悩み<br />コンテンツ</h2>
        </div>
      </div>
    </div>
    <div class="worries-column" style="margin-bottom: 6%;">
      <div class="use-scene-block">
        <router-link to="/column/53">
          <div class="use-scene-block-header">
            順番待ちのお客様を呼び出したいアミューズメント施設向きのツールとは
          </div>
        </router-link>
        <p>
          お客様がアミューズメント施設内の好きな場所で待てるようにしつつ、呼び出しやすくするためには呼び出しベルがおすすめです。アミューズメント施設向けの呼び出しベルを紹介します。
        </p>
      </div>
      <div class="use-scene-block">
        <router-link to="/column/49">
          <div class="use-scene-block-header">
            離れた駐車場で待つ患者さんを呼び出したいときに便利な呼び出しベル4選
          </div>
        </router-link>
        <p>
          感染対策として患者さんに離れた駐車場で待ってもらっている場合、呼び出すのに手間がかかります。駐車場の患者さんを呼び出すのに向いた呼び出しベル4種類を紹介します。
        </p>
      </div>
    </div>

    <div class="feature-section" id="spec">
      <div class="circle-parent">
        <div class="circle-heading green">
          <h2 class="circle-heading-title">仕様</h2>
        </div>
      </div>
      <div class="main-specification">
        <div class="specification-detail">
          <specs v-bind:useType="useType" v-bind:items="items" />
        </div>
      </div>
    </div>

    <div class="feature-section" id="price">
      <div class="circle-parent">
        <div class="circle-heading green">
          <h2 class="circle-heading-title">価格</h2>
        </div>
      </div>
      <div class="main-specification">
        <div class="specification-detail">
          <prices
            v-bind:items="
              items.filter(function(item) {
                return (
                  (item.listPrice > 0 && item.regularPrice > 0) ||
                  item.openPrice > 0 ||
                  item.summaryImagePath
                )
              })
            "
          />
        </div>
      </div>
    </div>

    <div class="feature-section" id="catalogue">
      <div class="circle-parent">
        <div class="circle-heading green">
          <h2 class="circle-heading-title">カタログ</h2>
        </div>
      </div>
      <div class="main-specification">
        <div class="specification-detail">
          <catalogues
            v-bind:useType="useType"
            v-bind:productName="productName"
            v-bind:items="catalogues"
            v-bind:appDownloadUrl="appDownloadUrl"
          />
        </div>
      </div>
    </div>

    <div class="product_question">
      <h2 style="color: #0a518d">よくある質問</h2>
      <question-and-answer
        :number="1"
        :question="'受信機に信号が届いたかどうか確認できますか？'"
        :answer="
          `登録コードが受信機に届いたか、受信者が受信を確認したかどうかを、PCの画面上の通信履歴をアイコンで確認できます。通信エラーになった場合には、PCから簡単操作で登録コードを再送できるため、業務をスムーズに進行できます。`
        "
      />
      <question-and-answer
        :number="2"
        :question="'リプライコールをＰＣで操作できますか？'"
        :answer="
          `送信機とWindows PCをUSB接続することにより、マウス操作やタッチパネル操作での受信機呼び出しや登録コードの送信などが可能です。従来のリプライコールを上回る高機能&高操作性を実現しています。`
        "
      />
      <question-and-answer
        :number="3"
        :question="'受信機は何台まで呼出し出来ますか？'"
        :answer="
          `1台のリプライコール PC送信機から受信機は最大500台まで対応しています。また、PC側で255の登録コードの管理に対応。受信機へワンタッチで登録コードを送信できます。※1~FFまでの英数字の組み合わせ。`
        "
      />
    </div>

    <div class="column_nav">
      <h2 style="color: #0a518d">おすすめのコンテンツ</h2>
      <ul
        style="width: 100%; max-width: 960px; margin: 0 auto; box-sizing: border-box;"
      >
        <li>
          <a href="/choice/industry/10" target="_blank"
            ><img
              src="/static/columns/23/large_scale_facility_mv.png"
              alt="大規模施設の呼出しベルについて"
          /></a>

          <h3>
            <a href="/choice/industry/10" target="_blank"
              >大規模施設の呼出しベルについて</a
            >
          </h3>
        </li>
        <li>
          <a href="/column/11" target="_blank"
            ><img
              src="/static/columns/11/img_waiting_room_call_bell1.jpg"
              alt="待合室に呼び出しベルを導入して混雑を緩和！使い方や導入のポイントも"
          /></a>

          <h3>
            <a href="/column/11" target="_blank"
              >待合室に呼び出しベルを導入して混雑を緩和！使い方や導入のポイントも</a
            >
          </h3>
        </li>
        <li>
          <a href="/column/12" target="_blank"
            ><img
              src="/static/columns/12/img_parking_lot_call_bells1.jpg"
              alt="駐車場での呼び出しベル活用例5選！導入の注意点とおすすめ機種も"
          /></a>

          <h3>
            <a href="/column/12" target="_blank"
              >駐車場での呼び出しベル活用例5選！導入の注意点とおすすめ機種も</a
            >
          </h3>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import ProductFeatureSummary from '@/components/modules/ProductFeatureSummary'
import ContentHeader from '@/components/modules/ContentHeader'
import Specs from '@/components/modules/Specs'
import Prices from '@/components/modules/Prices'
import Catalogues from '@/components/modules/Catalogues'
import QuestionAndAnswer from '@/components/modules/QuestionAndAnswer'

export default {
  components: {
    ProductFeatureSummary,
    ContentHeader,
    Specs,
    Prices,
    Catalogues,
    QuestionAndAnswer,
  },
  data() {
    return {
      productName: 'reply-call',
      useType: 1,
      items: [
        {
          name: '送信機',
          imagePath: '/static/products/reply-call-pc/items/item_01.png',
          spec: {
            型式: 'RE-101',
            サイズ: '170（W）×85（D）×40（H）mm',
            重量: '約 200g',
            電源: `100V DC6V ダプター
            単三アルカリ乾電池使用可能（3 本）`,
            周波数: '426.025～426.1375MHz 特定小電力',
            チャンネル: '20 チャンネル',
            到達距離: '約 100m',
            送信: `受信機 500 台
            対応受信確認機能有り
            受信不可通知機能有り`,
            一斉送信: '0 + コール',
            消費電力: '約 3W（ピーク時）',
          },
          comment: '※アプリ・USB ケーブル・インストーラー付',
          priceName: `送信操作機（RE-101）
          アプリ・USB ケーブル・インストーラー含`,
          listPrice: 80000,
          regularPrice: 56000,
        },
        {
          name: '受信機',
          imagePath: '/static/products/reply-call-pc/items/item_02.png',
          spec: {
            型式: 'RE-201',
            サイズ: '51（W）×116（D）×19（H）mm',
            重量: '100g（電池パック含む）',
            電源: 'リチウムポリマー充電池',
            周波数: '426.025～426.1375MHz 特定小電力',
            チャンネル: '20 チャンネル',
            動作: `受信 LED・7 セグ LED・ブザー音・
            バイブレーション
            受信音量 2 段切替有り
            送信機番号表示（255 台）可能
            0℃でバイブレーション作動不可`,
            電池残量確認: '赤色 LED バー点滅速度で表示 ',
            連続待受時間: `約 30 時間以上（圏内時、フル充電時）
            圏外表示機能有り・E（エラー表示）`,
            アンテナ: '内蔵式',
          },
          priceName: `携帯受信機（RE-201）`,
          listPrice: 28000,
          regularPrice: 19600,
        },
        {
          name: '充電器 5台用',
          imagePath: '/static/products/reply-call-pc/items/item_03.png',
          spec: {
            型式: 'RE-305',
            サイズ: '79（W）×165（D）×54（H）mm',
            重量: '約 400g',
            電源: '100V DC6V アダプター',
            充電時間: '約 6 時間',
            充電: `接点充電
            収納部セパレート方式（掃除可能）`,
            消費電力: '約 12W（ピーク時）',
          },
          priceName: `充電器 5 台タイプ（RE-305） `,
          listPrice: 25000,
          regularPrice: 17500,
        },
        {
          name: '充電器 10台用',
          imagePath: '/static/products/reply-call-pc/items/item_04.png',
          spec: {
            型式: 'RE-310',
            サイズ: '79（W）×290（D）×54（H）mm',
            重量: '550g',
            電源: '100V DC6V アダプター',
            充電時間: '約 6 時間',
            充電: `接点充電
            収納部セパレート方式（掃除可能）`,
            消費電力: '約 24W（ピーク時）',
          },
          priceName: `充電器 10 台タイプ（RE-310）`,
          listPrice: 30000,
          regularPrice: 21000,
        },
        {
          name: '中継機',
          imagePath: '/static/products/reply-call-pc/items/item_05.png',
          spec: {
            型式: 'RE-400',
            電源: '100V DC6V アダプター',
            サイズ: '170（W）×85（D）×40（H）mm',
            重量: '約 200g',
            周波数: '426.025～426.1375MHz　特定小電力',
            チャンネル: '20 チャンネル',
            signalStrength: '有り',
            到達距離: '対送信機 約 100m　対受信機 約 100m',
            設定番機: '同一チャンネルエリア 1～8 番機',
            消費電力: '約 3W（ピーク時）',
          },
          priceName: `中継機（RE-400）`,
          listPrice: 30000,
          regularPrice: 21000,
        },
      ],
      catalogues: [
        {
          id: 1,
          name: 'リプライコールPC',
          imagePath:
            '/static/products/reply-call-pc/catalogues/catalogue_01.jpg',
          downloadUri:
            '/static/products/reply-call-pc/catalogues/catalogue_01.pdf',
          pageCount: 2,
          fileType: 'PDF',
          fileSize: '約 791KB',
        },
        {
          id: 2,
          name: 'リプライコールPC 取り扱い説明書',
          imagePath:
            '/static/products/reply-call-pc/catalogues/catalogue_02.jpg',
          downloadUri:
            '/static/products/reply-call-pc/catalogues/catalogue_02.pdf',
          pageCount: 16,
          fileType: 'PDF',
          fileSize: '約 6.6MB',
        },
      ],
      appDownloadUrl: 'https://echo5555.co.jp/products/reply_pc_appli.php',
    }
  },
}
</script>

<style scoped>
.feature-section .header h3 {
  color: rgb(45, 183, 68);
  font-size: 1.5em;
}

.feature-section .operation-flow {
  width: 900px;
  margin: 0 auto;

  border-radius: 5px;
  background-color: rgb(218, 243, 225);
}

.feature-section .operation-flow .body {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  margin: 20px 0;
}

.feature-section .operation-flow .body .operation-block {
  align-self: flex-start;

  width: 350px;
  margin-bottom: 30px;

  text-align: left;
}

.feature-section .operation-flow .body .operation-block img {
  width: auto;
  height: 190px;

  border: 1px solid rgb(45, 183, 68);
}

.feature-section .operation-flow .body .operation-block .operation-block-title {
  font-weight: bold;
  line-height: 20px;

  margin: 5px 0 10px;
}

.feature-section .operation-flow .body .operation-block p {
  font-size: 13px;

  margin: 0;
}

.feature-section .operation-flow .body .operation-block p img {
  border: none;
}

.feature-section .operation-flow .body .operation-arrow {
  width: 0;
  height: 0;
  margin: 82.5px 20px;

  border-top: 15px solid transparent;
  border-bottom: 15px solid transparent;
  border-left: 15px solid rgb(125, 212, 141);
}

.feature-section .operation-flow .body .operation-empty {
  width: 55px;
}

.feature-section .main-function {
  background-color: rgb(242, 246, 250);
}

.feature-section .main-function .body {
  justify-content: space-between;

  padding: 0 5%;

  text-align: left;
}

.feature-section .main-function .body .main-image {
  width: 100%;
  height: auto;
  margin-bottom: 15px;

  border: 1px solid rgb(45, 183, 68);
  border-radius: 5px;
}

.feature-section .main-function .body .function {
  width: 46%;
  margin-bottom: 30px;
}

.feature-section .main-function .body .function .function-title {
  font-size: 20px;
  font-weight: bold;

  padding-bottom: 10px;

  color: rgb(45, 183, 68);
  border-bottom: 1px solid rgb(45, 183, 68);
}

.feature-section .main-function .body .function .function-detail {
  font-size: 14px;

  margin-top: 10px;
}

.feature-section .main-function .body .function img {
  width: 100%;
  height: auto;
  margin-top: 10px;
}

.appeal-block {
  width: 100%;
  margin: 15px 0 50px;
  padding: 25px 40px;

  border: 1px solid rgb(73, 195, 108);
  border-radius: 10px;
  background-color: white;
}

.appeal-block .appeal-title {
  font-size: 20px;
  font-weight: bold;

  margin-bottom: 15px;

  color: rgb(45, 183, 68);
}

.appeal-block .appeal-detail {
  font-size: 14px;

  display: inline-block;

  vertical-align: middle;
}

.feature-section .system-config {
  background: linear-gradient(rgb(228, 236, 243), white);
}

.feature-section .system-config img {
  width: 90%;
  max-width: 1100px;
  padding: 120px 0 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/products/features/ReplyCallPc.vue